<template>
    <div class="message select-reservation-day">
        <DayList :reservationDetail="reservationDetail" :data="data" v-if="Object.keys(reservationDetail).length > 0" />
    </div>
</template>

<script>
import log2 from "../../../../utils/log2";
import _ from "lodash";
import { mapState } from "vuex";
import { CALENDAR_API } from "../../../../api/calendar";
import DayList from "./DayList.vue";

const log = log2("SelectReservationDay");
export default {
    name: "SelectReservationDay",
    components: {
        DayList,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            reservationDetail: {},
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => _.get(state.site.site, "_id"),
        }),
    },
    methods: {},
    mounted() {
        console.log("SelectReservationDay worked", { data: this.data, message: this.message });
        CALENDAR_API.getReservationPlan(this.data.reservationPlanId).then((res) => {
            console.log("getReservationPlan res.data...", res);
            this.reservationDetail = res;
        });
    },
    beforeDestroy() {},
    watch: {},
};
</script>

<style lang="scss">
.select-reservation-day {
    background-color: white;
    border-radius: 10px;
    max-height: 250px;
    display: flex;
    overflow-x: auto;
    width: 100%;
}
</style>
